import {Link} from '@shopify/hydrogen';
import {estimatedArrivalDate, textDate} from '../../lib/hatcherybrain';
import {
  CheckCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/20/solid';
import {useHatcheryBrainCart} from '../hooks/HatcheryBrainCart.client';

export function CartAvailabilityMessage({onClose}: {onClose?: () => void}) {
  const response = useHatcheryBrainCart();

  if (!response) {
    return null;
  }

  if (
    !response?.possibleCartDates ||
    response?.possibleCartDates?.length <= 0
  ) {
    return <NoAvailableHatchDates />;
  }

  const nextDate = textDate(response?.possibleCartDates[0]);

  const estimatedArrival = estimatedArrivalDate(response?.possibleCartDates[0]);

  return (
    <section className="rounded-md bg-blue-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon
            className="h-5 w-5 text-blue-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <div className="text-md font-semibold text-blue-700">
            {`Your order will be scheduled to hatch on `}
            <span className="text-lg font-bold">{nextDate}.</span>
          </div>
          <div className="mt-2 text-sm text-blue-700">
            <p>{`Your order is estimated to arrive by ${estimatedArrival}.`}</p>
          </div>
          {response?.possibleCartDates?.length > 1 && (
            <div className="mt-2 text-sm text-blue-700">
              <p>{`There are later dates you can select from at checkout as well.`}</p>
            </div>
          )}

          <div className="mt-4">
            <div className="-mx-2 -my-1.5 flex">
              <button
                onClick={onClose}
                type="button"
                className="rounded-md bg-blue-50 px-2 py-1.5 text-sm font-medium text-blue-800 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-blue-50"
              >
                <Link to="/cart#date-details">
                  See Availability Breakdown{' '}
                  <span aria-hidden="true"> &rarr;</span>
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function NoAvailableHatchDates() {
  return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            There are no available hatch dates for your order.
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>
              Adjust your order so that all live products are available on a
              common hatch date.
            </p>
            <div className="mt-4">
              <div className="-mx-2 -my-1.5 flex">
                <button
                  type="button"
                  className="rounded-md bg-red-50 px-2 py-1.5 text-sm font-medium text-red-800 hover:bg-red-100 
                  focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
                >
                  <Link to="/cart#date-details">
                    See Availability Breakdown{' '}
                    <span aria-hidden="true"> &rarr;</span>
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
